import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { CLASS_COMPONENT } from '../../common';

export const SpacedElements = styled.div.attrs<{ $classModifier?: string }>(
  ({ $classModifier }) => ({
    className: createReadableClass({
      component: CLASS_COMPONENT,
      element: 'spaced-elements',
      modifier: $classModifier
    })
  })
)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  color: inherit;
`;
